import { LoadingSpinner } from "./LoadingSpinner";

type CoveringLoadingSpinnerProps = {
  surface?: string;
};

export const CoveringLoadingSpinner: React.FC<CoveringLoadingSpinnerProps> = ({
  surface = "surface-primary opacity-50",
}) => {
  return (
    <div
      // h-dvh/w-screen kept alongside inset-0 on purpose: a transformed
      // ancestor (mid sheet/scale animation) turns it into the fixed
      // containing block, and explicit viewport units keep the overlay
      // full-screen even then.
      className={`fixed inset-0 ${surface} flex items-center justify-center h-dvh w-screen z-50 pointer-events-auto sm:pr-[var(--ai-rail-push)] transition-[padding] duration-[250ms] ease-[cubic-bezier(0.4,0,0.2,1)] motion-reduce:transition-none`}
    >
      <LoadingSpinner />
    </div>
  );
};
